/**
* @file Column component for displaying a color value.
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { ColorTools } from '../../base/helpers/color-tools';
import { ComponentRegistry } from '../../core/component-registry';
import { ColumnProvider } from '../../base/column-provider';
import { ColumnBase } from '../../base/columns/column-base/column-base';
/**
 * Column component for displaying a color value
 */
var ColumnColorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnColorComponent, _super);
    /**
     * Constructs a ColumnColorComponent.
     * @param provider Provides the configuration information for the column.
     */
    function ColumnColorComponent(provider, changeDetector) {
        var _this = _super.call(this, provider, changeDetector) || this;
        /** Set of color tools */
        _this.colorTools = new ColorTools();
        return _this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnColorComponent.register = function () {
        ComponentRegistry.register('column', 'color', ColumnColorComponent);
    };
    Object.defineProperty(ColumnColorComponent.prototype, "colorPattern", {
        /**
         * Presentation of the color is based on the entity type.
         * Options are:
         * - assignment (= default)
         * - appointment
         * - absence
         */
        get: function () {
            switch (this.provider.entity.entityType.shortName) {
                case 'Task':
                case 'TaskTemplate':
                case 'Assignment':
                    if (this.provider.entity['Appointment']) {
                        // Assignments met waarde true voor de property Appointment worden binnen HTML5 als Appointments gezien.
                        return 'appointment';
                    }
                    return 'assignment';
                case 'Appointment':
                    // Eerder hielde we rekening met Appointments die geen Absence als reden hadden.
                    // Van deze Symagic Server mogelijkheid wordt geen gebruik gemaakt.
                    // Appointments behoren nu functioneel altijd een Absence als reden te hebben.
                    return 'absence';
                case 'Shift':
                    return 'service';
                case 'Service':
                    return 'service';
                case 'Attendant':
                    return 'service';
                default:
                    return 'assignment';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnColorComponent.prototype, "color", {
        get: function () {
            return this.colorTools.getDisplayColor(this.provider.value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets a value indicating whether the planned item is in draft.
     */
    ColumnColorComponent.prototype.isDraft = function () {
        return this.provider.entity && this.provider.entity.Draft;
    };
    return ColumnColorComponent;
}(ColumnBase));
export { ColumnColorComponent };
